export default __webpack_public_path__ + "static/media/47t.64e8a3f4.jpg";